import api from "../../api";
import Lottie from "react-lottie-player";
import values from "../../values";
import anLogin from "../../../assets/animations/an-Login.json";
import * as Yup from "yup";

import React from "react";

import { IItem, Role } from "../../types/common.interface";
import { Col, Container, Row } from "react-bootstrap";
import {
  CustomButton2,
  CustomInput,
  CustomRadioButtonGroup,
} from "../../components";

import "./index.scss";
import { useFormik } from "formik";
import validations from "../../validations";
import { Link } from "react-router-dom";
import Navigation from "../../../website/screen/HomeScreen/Components/Navigation";
interface iData {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  userName: string;
  password: string;
  rePassword: string;
}

// const {
//   loadCaptchaEnginge,
//   LoadCanvasTemplate,
//   LoadCanvasTemplateNoReload,
//   validateCaptcha,
// } = require("react-simple-captcha");

const SignUpScreen = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isOtpSend, setIsOtpSend] = React.useState<boolean>(false);
  // const [captchaValue, setCaptchaValue] = React.useState<string>("");
  // const [captchaError, setCaptchaError] = React.useState<string>("");
  const [errors, setErrors] = React.useState<any>({});
  const [selectedRole, setSelectedRole] = React.useState<IItem | null>(
    values.topMenuItems.LOGIN_ROLE_ITEM[0]
  );
  const [data, setData] = React.useState<iData>({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    userName: "",
    password: "",
    rePassword: "",
  });

  // ============================================== Use queries =======================================

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      userName: "",
      password: "",
      rePassword: "",
    },
    validationSchema: Yup.object({
      firstName: validations.yupValidations.firstName,
      lastName: validations.yupValidations.lastName,
      phoneNumber: validations.yupValidations.phoneNumber,
      userName: validations.yupValidations.userName,
      password: Yup.string().required("فیلد گذرواژه اجباری است"),
    }),
    onSubmit: async (values) => {
      await api.postMethod.common.signUp({
        ...values,
        role: selectedRole?.value as Role,
      });
    },
  });

  // ============================================== functions =======================================

  const onRoleChange = (item: IItem | null) => {
    setSelectedRole(item);
  };

  const onSubmit = async () => {
    if (formik.values.password === formik.values.rePassword) {
      setErrors({ rePassword: "" });
      formik.submitForm();
    } else {
      setErrors({ rePassword: "تکرار گذرواژه اشتباه است" });
    }
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      onSubmit();
    }
  };

  // useEffect(() => {
  //   loadCaptchaEnginge(4, "lightgray", "black", "numbers"); // loadCaptchaEnginge(Number_Of_Captcha_Charcters, Background_Color, Font_Color, Special_Characters);
  // }, []);

  return (
    <>
      <Navigation />

      <section id="login-screen-container">
        <Container fluid>
          <Row>
            <Col lg={6}>
              <div className="left-side">
                <div className="login-card">
                  <h1>ثبت نام</h1>
                  <div>
                    <CustomRadioButtonGroup
                      menus={values.topMenuItems.LOGIN_ROLE_ITEM}
                      selected={selectedRole}
                      onClick={onRoleChange}
                      canNull={false}
                      themeColor={"#98C226"}
                    />
                  </div>
                  <div className="phone-number-holder">
                    <Row>
                      <Col lg={6}>
                        <div className="enter-number-container">
                          <CustomInput
                            name="firstName"
                            id="firstName"
                            value={formik.values.firstName}
                            onValueChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label="نام"
                            placeHolder="نام"
                            textAlign="center"
                            error={
                              formik.errors.firstName &&
                              formik.touched.firstName
                            }
                            errorText={formik.errors.firstName}
                            // leftIcon="fas fa-mobile"
                            // onKeyDown={handleKeyDown}
                          />
                        </div>
                      </Col>{" "}
                      <Col lg={6}>
                        <div className="enter-number-container">
                          <CustomInput
                            name="lastName"
                            id="lastName"
                            value={formik.values.lastName}
                            onValueChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label="نام خانوادگی"
                            placeHolder="نام خانوادگی"
                            textAlign="center"
                            error={
                              formik.errors.lastName && formik.touched.lastName
                            }
                            errorText={formik.errors.lastName}
                            // leftIcon="fas fa-mobile"
                            // onKeyDown={handleKeyDown}
                          />
                        </div>
                      </Col>
                    </Row>{" "}
                    <Row>
                      <Col lg={6}>
                        <div className="enter-number-container">
                          <CustomInput
                            name="phoneNumber"
                            id="phoneNumber"
                            value={formik.values.phoneNumber}
                            onValueChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label="شماره موبایل"
                            placeHolder="شماره موبایل"
                            textAlign="center"
                            error={
                              formik.errors.phoneNumber &&
                              formik.touched.phoneNumber
                            }
                            errorText={formik.errors.phoneNumber}
                          />
                        </div>
                      </Col>{" "}
                      <Col lg={6}>
                        <div className="enter-number-container">
                          <CustomInput
                            name="userName"
                            id="userName"
                            value={formik.values.userName}
                            onValueChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label="نام کاربری"
                            placeHolder="نام کاربری"
                            textAlign="center"
                            error={
                              formik.errors.userName && formik.touched.userName
                            }
                            errorText={formik.errors.userName}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <div className="enter-number-container">
                          <CustomInput
                            type="password"
                            name="password"
                            id="password"
                            value={formik.values.password}
                            onValueChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label="گذرواژه"
                            placeHolder="گذرواژه"
                            textAlign="center"
                            error={
                              formik.errors.password && formik.touched.password
                            }
                            errorText={formik.errors.password}
                            isPassword
                          />
                        </div>
                      </Col>{" "}
                      <Col lg={6} className="dropdown">
                        <div className="enter-number-container">
                          <CustomInput
                            type="password"
                            name="rePassword"
                            id="rePassword"
                            value={formik.values.rePassword}
                            onValueChange={(event) => {
                              formik.values.password === event.target.value
                                ? setErrors({ rePassword: "" })
                                : setErrors({
                                    rePassword: "تکرار گذرواژه اشتباه است",
                                  });
                              formik.handleChange(event);
                            }}
                            onBlur={formik.handleBlur}
                            label="تکرار گذرواژه"
                            placeHolder="تکرار گذرواژه"
                            textAlign="center"
                            isPassword
                          />
                        </div>
                        <div className="error">
                          {errors.rePassword !== "" && errors.rePassword}
                        </div>
                      </Col>
                    </Row>
                    {/* <Row className="captcha dropdown">
                    <Column medium={6}>
                      <div className="input-block">
                        <CustomInput
                          type="text"
                          id="captcha"
                          name="captcha"
                          value={captchaValue}
                          placeHolder={"عبارت امنیتی را وارد نمایید"}
                          onValueChange={(event) =>
                            setCaptchaValue(event.target.value)
                          }
                          onKeyDown={handleKeyDown}
                        />
                        
                      </div>
                    </Column>
                    <Column medium={5} className="reload-captcha-column">
                      <LoadCanvasTemplate reloadText={`بارگذاری مجدد`} />
                    </Column>
                    <div className="error">{captchaError}</div>
                  </Row> */}
                  </div>
                  <CustomButton2
                    isLoading={isLoading}
                    onClick={onSubmit}
                    title={"ثبت نام"}
                    type="primary"
                  />
                  <Row className="sign-up-text">
                    <Col>ثبت نام کرده اید؟</Col>
                    <Col>
                      <Link to={"/panel/login"}>
                        <CustomButton2
                          title={"ورود"}
                          type="secondary"
                          onClick={() => false}
                        />
                      </Link>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="right-side">
                <Lottie
                  loop
                  animationData={anLogin}
                  play
                  style={{ width: "100%", height: "90%" }}
                />
                {/* <div className="animation-subtitle">
                <div className="login-text">
                  <p>{"constants.LOGIN_SUBTITLE"}</p>
                  <p>{"constants.LOGIN_DESCRIPTION"}</p>
                </div>
              </div> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SignUpScreen;
